import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { userIsLoggedIn } from "../utils/UserAuth";

export const AuthRoute = () => {
	const isLoggedIn = userIsLoggedIn();

	return !isLoggedIn ? <Outlet /> : <Navigate to='/' replace={true} />;
};

export default AuthRoute;
